export function isInternetExplorer(ua: string): boolean {
    return /msie\s|trident\/|edge\//i.test(ua);
}
